/**
 * LiveBadge — the single shared "Élő adat" affordance (§2.3). Replaces the four+
 * inline emerald pills scattered across PassFieldRow, BarcodeEditor,
 * SemanticsEditor and RelevanceEditor. Renders the same emerald pill PLUS a
 * HelpHint carrying the one canonical explanation of why a value is read-only.
 * Presentational only.
 */
import { HelpHint } from './HelpHint';

const LIVE_EXPLANATION =
  'Az értéket a valós járat adja a pass létrehozásakor. Itt csak a címkéjét és a ' +
  'formátumát állítod be; a mezőt mintáláskor a rendszer tölti ki.';

export interface LiveBadgeProps {
  /**
   * Override for the canonical (flight-flavoured) explanation — the generic
   * (no-flight) canvas passes neutral copy, since "a valós járat adja" would
   * be flatly untrue for a pass that has no flight.
   */
  explanation?: string;
}

export function LiveBadge({ explanation = LIVE_EXPLANATION }: LiveBadgeProps): JSX.Element {
  return (
    <span className="inline-flex items-center gap-1">
      <span className="rounded bg-emerald-100 px-1.5 py-0.5 text-[10px] font-medium text-emerald-700">
        Élő adat
      </span>
      <HelpHint text={explanation} label="Élő adat súgó" />
    </span>
  );
}
